export const OapBadge = ({ v }) => (
  <span className={`text-[11px] px-2 py-0.5 rounded-full border whitespace-nowrap ${v === "OAP" ? "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" : "bg-amber-500/10 text-amber-700 border-amber-500/30"}`}>{v}</span>
);

const EKO = {
  Miskin: "bg-rose-500/10 text-rose-700 border-rose-500/30",
  "Tidak Mampu": "bg-orange-500/10 text-orange-700 border-orange-500/30",
  Mampu: "bg-sky-500/10 text-sky-700 border-sky-500/30",
};
export const EkoBadge = ({ v }) => (
  <span className={`text-[11px] px-2 py-0.5 rounded-full border whitespace-nowrap ${EKO[v] || "bg-slate-100 text-slate-600"}`}>{v}</span>
);
